import "./App.css";
import React from "react";

import { initializeApp } from "firebase/app";

import logo from "./assets/logo.png";

const firebaseConfig = {
  apiKey: "AIzaSyCIF1_dbZ3UHMe1x3Fxtu-GB0mYwzrh5Mo",
  authDomain: "edgen-396119.firebaseapp.com",
  projectId: "edgen-396119",
  storageBucket: "edgen-396119.appspot.com",
  messagingSenderId: "24981225358",
  appId: "1:24981225358:web:8d25824e0337c6ea8caedf",
  measurementId: "G-5C6JLFCYD2",
};

export const app = initializeApp(firebaseConfig);
function App() {
  return (
    <div>
      <h1>Edgen</h1>
      <img src={logo} alt="logo" />
    </div>
  );
}

export default App;
